import { LinearProgress } from "@material-ui/core";
import Axios from "axios";
import Moments from "moment";
import React, { Component } from "react";
import {
  Alert,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import AppConfig from "../../../../config/AppConfig";
import BentukEvaluasiOnly from "./BentukEvaluasiOnly";
class BentukEvaluasiLainnya extends Component {
  constructor(props, context) {
    super(props, context);
    this.showModalsEvaluasiLain = this.showModalsEvaluasiLain.bind(this);
    this.showEditEvaluasiLain = this.showEditEvaluasiLain.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      loading: false,
      loadingList: false,
      display: false,
      showModalsEvaluasiLain: false,
      showEditEvaluasiLain: false,
      get_pengaturan: [],
      // state form
      id_evaluasi: [],
      keterangan: [],
      deskripsi: [],
      tautan: [],
      tanggal_penetapan: [],
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    };
  }
  showModalsEvaluasiLain() {
    this.setState({ showModalsEvaluasiLain: true });
  }
  showEditEvaluasiLain(data) {
    this.setState({
      showEditEvaluasiLain: true,
      id_evaluasi: data.id_ajuan_evaluasi !== "null" ? data.id_ajuan_evaluasi : "",
      keterangan: data.keterangan !== "null" ? data.keterangan : "",
      deskripsi: data.deskripsi !== "null" ? data.deskripsi : "",
      tautan: data.tautan !== "null" ? data.tautan : "",
      tanggal_penetapan: data.tanggal_penetapan !== "null" ? Moments(data.tanggal_penetapan).format("YYYY-MM-DD") : "",
    });
  }
  handleClose() {
    this.setState({
      showModalsEvaluasiLain: false,
      showEditEvaluasiLain: false,
      id_evaluasi: "",
      keterangan: "",
      tautan: "",
      deskripsi: "",
      tanggal_penetapan: "",
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    });
  }
  onInputChange = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  handleSaveEvaluasiLainnya = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        swal({
          title: "Apakah anda yakin?",
          text: "Simpan catatan dari evaluasi yang dilakukan",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        }).then((willsave) => {
          if (willsave) {
            this.setState({ loading: true });
            var formData = new FormData();
            formData.append("data[id_ajuan_evaluasi]", this.state.id_evaluasi);
            formData.append("data[tautan]", this.state.tautan);
            formData.append("data[deskripsi]", this.state.deskripsi);
            let session_tahun_siklus = localStorage.getItem("tahun_siklus")
            formData.append("data[tahun_siklus]", session_tahun_siklus);
            formData.append("data[id_jenis_evaluasi]", 8);
            formData.append(
              "data[tanggal_penetapan]",
              this.state.tanggal_penetapan
            );
            formData.append("data[status]", 1);
            formData.append("data[keterangan]", this.state.keterangan);
            formData.append("data[id_sp]", sessiondata.i_idunit);
            Axios.defaults.headers.post["Content-Type"] =
              "application/x-www-form-urlencoded";
            Axios.post(AppConfig.urlPostEvaluasi + session, formData)
              .then((res) => {
                swal({
                  title: "Berhasil!",
                  text: "Penyimpanan Evaluasi lainnya berhasil!",
                  icon: "success",
                  button: "OK!",
                });
                this.componentDidMount();
                this.setState({
                  loading: false,
                  showModalsEvaluasiLain: false,
                  showEditEvaluasiLain: false,
                  deskripsi: "",
                  id_evaluasi: "",
                  keterangan: "",
                  tautan: "",
                  tanggal_penetapan: "",
                });
              })
              .catch((err) => {
                swal({
                  title: "Gagal!",
                  text: "Penyimpanan evaluasi lainnya gagal!",
                  icon: "error",
                  button: "OK!",
                });
                // alert("GAGAL")
                this.setState({
                  loading: false,
                  showModalsEvaluasiLain: false,
                  showEditEvaluasiLain: false,
                  id_evaluasi: "",
                  keterangan: "",
                  tautan: "",
                  tanggal_penetapan: "",
                });
              });
          }
        });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  componentDidMount() {
    this.setState({ display: false, loadingList: true });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let session_tahun_siklus = localStorage.getItem("tahun_siklus");
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole +
         "&is_history=0";
    }
    Axios.get(AppConfig.urlGetEvaluasiLainSiklus + id_sp + "/" + 8 + "/" + session_tahun_siklus + session)
      .then((res) => {
        this.setState(
          {
            get_pengaturan: res.data.result.data,
            display: false,
            loadingList: false,
          },
          () => {
            console.log(this.state.get_pengaturan.id_ajuan_evaluasi);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handhandleShowHistorical = (jenis) => {
    // console.log(jenis);
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole+
         "&is_history=1";
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined || id_institusi === null) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    Axios.get(
      AppConfig.urlGetEvaluasiLainSiklus + id_institusi + "/" + jenis + "/" + tahun_siklus + session
    )
      .then((res) => {
        console.log(res);
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({
        //   display_edit: false,
        //   showDialogFormSave: false,
        // });
      });
  };

  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        Axios
          .get(AppConfig.urlDeleteEvaluasi + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan evaluasi lain berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
          });
      }
    });
  }
  render() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let {
      loading,
      keterangan,
      tautan,
      deskripsi,
      tanggal_penetapan,
      showModalsEvaluasiLain,
      showEditEvaluasiLain,
      get_pengaturan,
    } = this.state;

    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log(userdata);
    let idSp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      idSp = id_institusi;
    }
    if (id_institusi === null) {
      idSp = sessiondata.i_idunit;
    }
    if (this.props.idSp !== undefined) {
      idSp = this.props.idSp;
    }

    let EvalusasiLain = [];
    let i = 1;
    if (get_pengaturan !== undefined) {
      get_pengaturan.map((list, i) => {
        EvalusasiLain.push(
          <>
            <tr>
              <td className="text-center">{i++ + 1}.</td>
              <td>
                {(list.keterangan !== "null") ? list.keterangan : list.nm_jenis_evaluasi}
              </td>
              <td className="">
                <Button
                  href={list.tautan}
                  target="_blank"
                  className="btn btn-icon btn-light btn-md"
                  style={{
                    minWidth: "50px",
                    borderRadius: "12px",
                    background: "#A9C6DE",
                  }}
                >
                  <i
                    class="flaticon-attachment"
                    style={{ color: "#3F4254", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
              <td className="text-center">
               {
                list.tanggal_penetapan !== "null" ? (
                  <Moment date={list.tanggal_penetapan} format="DD/MM/YYYY" />
                ) : (
                  "-"
                )
               }
              </td>
              <td className="text-center">
                <Moment date={list.created_at} format="DD/MM/YYYY" />
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  verticalAlign: "top",
                }}
              >
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    Belum Terverifikasi
                  </Badge>
                )}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  verticalAlign: "top",
                }}
              >
                {list.statusdokumen === 1 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Sudah Valid
                  </Badge>
                ) : list.statusdokumen === 0 ? (
                  <Badge
                    pill
                    variant="warning"
                    style={{
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    Belum Valid
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                  >
                    Dokumen belum diverifikasi
                  </Badge>
                )}
              </td>
              <td className="text-center">
                {userdata.i_idrole === 10 ||
                  userdata.i_idrole === 2013 ||
                  userdata.i_idrole === 2014 ? (
                    <>
                  <Link to={"/ajuan-evaluasi/detail/" + list.id_ajuan_evaluasi}>
                    <Button
                      className="btn btn-icon btn-primary btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-eye"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </Link>
                  </>
                ) : userdata.i_idrole === 3 ? (
                  <>
                    <Link
                      to={"/ajuan-evaluasi/detail/" + list.id_ajuan_evaluasi}
                    >
                      <Button
                        className="btn btn-icon btn-primary btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          class="flaticon-eye"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </Link>
                      {list.statusajuan === 1 || (list.statusdokumen === "null" || list.statusdokumen === 0) ? (
                    <Button
                      onClick={() => this.showEditEvaluasiLain(list)}
                      className="btn btn-icon btn-warning btn-sm"
                      style={{
                        minWidth: "50px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        color: "#fff",
                        marginLeft: "5px",
                      }}
                    >
                      <i
                        class="flaticon-edit"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                      ) : ("")}
                      {list.statusajuan === 1 && (list.statusdokumen === "null" || list.statusdokumen === 0) ? (
                        <Button
                          onClick={() =>
                            this.showDialogDelete(
                              list.id_ajuan_evaluasi
                            )
                          }
                          className="btn btn-icon btn-danger btn-sm"
                          style={{
                            minWidth: "50px",
                            borderRadius: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          <i
                            className="flaticon-delete"
                            style={{ color: "#FFFFFF", fontSize: "14px" }}
                          ></i>
                        </Button>
                      ) : ("")}
                  </>
                ) : (
                  ""
                )}
                {list.id_jenis_evaluasi !== 8 ? (
                <Button
                  onClick={() =>
                    this.handhandleShowHistorical(list.id_jenis_evaluasi)
                  }
                  className="btn btn-icon btn-success btn-sm"
                  style={{
                    minWidth: "50px",
                    borderRadius: "12px",
                    marginLeft: "5px",
                  }}
                >
                  <i
                    class="flaticon2-time"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
        ):""}
              </td>
            </tr>
          </>
        );
      });
    } else {
      EvalusasiLain = (
        <>
          <tr>
            <td
              style={{
                minWidth: "100px",
                fontStyle: "italic",
                color: "#7d7d7d",
              }}
              className="text-center"
              colSpan="4"
            >
              {/* DATA KOSONG */}
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }

    let display_historical = [];
    if (this.state.loadingHistorical === true) {
      this.state.data_historical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "left" }}>
                {list.keterangan !== "null" ? (
                  list.keterangan
                ) : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tautan !== "null" ? (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-success btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                ) : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : list.statusajuan === 1 ? (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    -
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tanggal_penetapan === "null" ? (
                  "-"
                ) : (
                  <Moment
                    format="DD/MM/YYYY"
                    date={
                      list.tanggal_penetapan === "null"
                        ? "-"
                        : list.tanggal_penetapan
                    }
                  />
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.catatan === "null" ? "-" : list.catatan}
              </td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    return (
      <>
        {/* EVALUSI LAIN  */}
        <BentukEvaluasiOnly idSp={idSp} />
        <div className={``}>
          {/* BODY */}
          <div className="table-responsive" bordered={false}>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <ButtonToolbar style={{ float: "right", marginBottom: "10px" }}>
                <span className="svg-icon svg-icon-2x svg-icon-white">
                  <Button
                    variant="primary"
                    onClick={this.showModalsEvaluasiLain}
                  >
                    <i
                      class="flaticon-add-circular-button"
                      style={{ color: "#ffffff", fontSize: "14px" }}
                    ></i>
                    &nbsp; Tambahkan Laporan Pelaksanaan dan Hasil Evaluasi
                  </Button>
                </span>
              </ButtonToolbar>
            ) : (
              ""
            )}
            <Table responsive style={{ overflow: "auto" }}>
              <thead>
                <tr
                  className="text-left text-white"
                  style={{ backgroundColor: "#3047ad" }}
                >
                  <th>
                    <span className="svg-icon svg-icon-lg svg-icon-white text-uppercase">
                      No.
                    </span>
                  </th>
                  <th style={{ minWidth: "150px", textTransform: "uppercase" }}>
                    Laporan Pelaksanaan dan Hasil Evaluasi
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    <ButtonToolbar>
                      TAUTAN
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip id={`tooltip-${placement}`}>
                              <div style={{ textAlign: "left" }}>
                                Jika pengaturan tautan masih dalam berbentuk
                                soft file, pdf, dll, maka Perguruan Tinggi harus
                                menggunggah terlebih dahulu file tersebut dengan
                                menggunakan layanan penyimpanan online. Contoh{" "}
                                <em style={{}}> Dropbox, Google Drive dll</em>
                              </div>
                            </Tooltip>
                          }
                        >
                          <div>
                            &nbsp;&nbsp;
                            <span
                              style={{ fontSize: "15px" }}
                              className="text-white fa fa-info-circle"
                            ></span>
                          </div>
                        </OverlayTrigger>
                      ))}
                    </ButtonToolbar>
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    TANGGAL TERAKHIR DILAKUKAN
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    TANGGAL DIPERBARUI
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    STATUS VERIFIKASI
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    STATUS DOKUMEN
                  </th>
                  <th className="text-center" style={{ minWidth: "180px" }}>
                    <span style={{ marginRight: "10px" }}>AKSI</span>
                  </th>
                </tr>
              </thead>
              <tbody>{EvalusasiLain}</tbody>
            </Table>
          </div>
        </div>
        {/* Modals Dokumen Terkait evaluasi Lainnya*/}
        <Modal
          size="lg"
          show={showModalsEvaluasiLain}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Evaluasi Lainnya Yang Dilakukan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Bentuk evaluasi{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Nama bentuk evaluasi"
                value={keterangan}
                onChange={(e) => this.onInputChange(e, "keterangan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal terakhir evaluasi dilakukan
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={tanggal_penetapan}
                onChange={(e) => this.onInputChange(e, "tanggal_penetapan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSaveEvaluasiLainnya}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Dokumen Terkait EDIT evaluasi Lainnya*/}
        <Modal size="lg" show={showEditEvaluasiLain} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Evaluasi Lainnya Yang Dilakukan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Bentuk evaluasi{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                value={this.state.keterangan}
                onChange={(e) => this.onInputChange(e, "keterangan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal terakhir evaluasi dilakukan
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={this.state.tanggal_penetapan}
                onChange={(e) => this.onInputChange(e, "tanggal_penetapan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={this.state.tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSaveEvaluasiLainnya}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          show={this.state.showHistorical}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Riwayat Pengaturan Evaluasi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <th style={{ textAlign: "center" }}>Deskripsi</th>
                <th style={{ textAlign: "center" }}>Tautan</th>
                <th style={{ textAlign: "center" }}>Status Verfikasi</th>
                <th style={{ textAlign: "center" }}>Tanggal Penetapan</th>
                <th style={{ textAlign: "center" }}>Catatan</th>
              </thead>
              <tbody>{display_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default BentukEvaluasiLainnya;
